/**
 * <SystemStepBadge> — the single, fixed phrase every System-tier step renders as.
 *
 * There is deliberately NO per-file variant and nothing derived from the path:
 * the System tier has no lawyer-facing identity to derive (DS-37, operator-
 * ratified). Every system step reads identically — that is the design, not a
 * limitation. The lawyer learns that the concierge consulted the case's internal
 * record, which is true and sufficient; which internal file it read is an
 * implementation detail they were promised they would not see.
 */
import { FileCog } from "lucide-react";
import { useTranslation } from "react-i18next";

export function SystemStepBadge() {
  const { t } = useTranslation();
  return (
    <div
      data-testid="system-step-badge"
      className="my-1 inline-flex items-center gap-1.5 rounded border border-cream-300 bg-cream-100/30 px-2 py-1 text-caption text-coffee-600 dark:border-coffee-700 dark:bg-coffee-900/30 dark:text-cream-400"
    >
      <FileCog size={12} className="shrink-0" />
      <span>{t("chat.activity.systemStep")}</span>
    </div>
  );
}
